export default "__VITE_ASSET__D1Taob6C__"